import { enqueueSnackbar, VariantType } from 'notistack'
import { useTranslation } from 'react-i18next'

import { Product } from 'features/product'

type Snackbar = {
  enabled: boolean
  product: Product
  variant?: VariantType
}

export const useDomainsProductSnackbar = () => {
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'list.headerMenu.productToggle',
  })
  const { t: tProduct } = useTranslation('features/product')

  const snackbar = ({ enabled, product, variant }: Snackbar): void => {
    const tParams = {
      action: enabled ? 'enabled' : 'disabled',
      product: tProduct(`product.${product}`),
    }

    if (variant === 'error') {
      enqueueSnackbar(t('error', tParams), { variant })
    } else {
      enqueueSnackbar(t('success', tParams), {
        variant: enabled ? 'success' : 'warning',
      })
    }
  }

  return { snackbar }
}
